<div class="w-full py-3 px-4">

    <!-- Page Header: Title + Section Tab Switcher -->
    <div class="xl:flex items-center justify-between mb-4 gap-4">

        <!-- Title -->
        <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
            <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/user/create-user.png" alt="user">
            <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
            {{ activeSection === 'customers' ? 'GST Customer List' : activeSection === 'staff-list' ? 'GST Staff List' : activeSection === 'access-control' ? 'Staff Access Control' : 'Add GST Staff' }}
            </span>
        </div>

        <!-- Section Tab Switcher -->
        <div class="overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-hide md:overflow-x-hidden">
            <div class="min-w-max flex justify-end items-center">
                <div class="flex justify-start items-center">
                    <button
                        *ngFor="let section of sectionTabs; let i = index"
                        type="button"
                        (click)="switchSection($any(section.id))"
                        [ngClass]="{
                            'rounded-tl-[5px] rounded-bl-[5px]': i === 0,
                            'rounded-tr-[5px] rounded-br-[5px]': i === sectionTabs.length - 1,
                            'bg-c19725 text-white font-semibold border-c19725 hover:bg-c19725 hover:text-white': activeSection === section.id,
                            'bg-white text-[#898989] border-[#D9D9D9] hover:bg-[#f6f1cb] hover:text-black': activeSection !== section.id
                        }"
                        class="flex-1 px-4 py-2 border-[0.50px] flex justify-center items-center text-sm sm:text-sm lg:text-base transition-all duration-200 cursor-pointer min-w-[120px]">
                        {{ section.label }}
                    </button>
                </div>
            </div>
        </div>

    </div>

    <!-- SECTION: Customer List -->
    <div *ngIf="activeSection === 'customers'">

        <!-- Filter Dropdown -->
        <div class="w-full sm:w-full md:w-1/3 lg:w-1/4 mb-6">
            <label for="customerType" class="block text-sm font-medium text-gray-700">
                Filter by Customer Type:
            </label>
            <select id="customerType"
                    name="customerType"
                    [(ngModel)]="selectedCustomerType"
                    (change)="onCustomerTypeChange()"
                    class="mt-2 block w-full pl-3 pr-10 py-2 text-base border border-gray-300
                           focus:outline-none focus:ring-indigo-500
                           focus:border-indigo-500 sm:text-sm rounded-md">
                <option value="">All Customers</option>
                <option *ngFor="let type of customerTypes" [value]="type">
                    {{ type }}
                </option>
            </select>
        </div>

        <div *ngIf="isLoadingCustomers" class="flex flex-col items-center justify-center py-16 text-gray-400">
            <p class="text-base font-medium">Loading customers...</p>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoadingCustomers && userCustomerList.length === 0" class="flex flex-col items-center justify-center py-16 text-gray-400">
            <svg class="w-16 h-16 mb-4 opacity-40" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="20" r="12" stroke="#C19725" stroke-width="2"/>
                <path d="M8 56c0-13.255 10.745-24 24-24s24 10.745 24 24" stroke="#C19725" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <p class="text-base font-medium">No customers found.</p>
        </div>

        <!-- Customer Grid -->
        <div *ngIf="!isLoadingCustomers && userCustomerList.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5">
            <div *ngFor="let customer of userCustomerList">
                <div class="border border-[#D9D9D9] rounded-lg bg-white px-4 py-4 flex items-center justify-between shadow-sm hover:shadow-md transition duration-200 cursor-pointer"
                     (click)="onCustomerCardClick(customer)">

                    <!-- Left Section -->
                    <div class="flex items-center gap-4">
                        <div class="w-16 h-16 bg-[#F9E698] rounded-md flex justify-center items-center cursor-pointer">
                            <img class="w-11 h-11 object-cover"
                                 [src]="customer?.documents?.[0]?.doc_user_img || '/assets/images/user/user-profile.png'"
                                 alt="user profile">
                        </div>
                        <div class="space-y-1 text-gray-700 text-sm">
                            <p class="text-base font-semibold text-gray-900">{{ customer.name }}</p>
                            <p>
                                <span class="mr-1">{{ customer.mobilenumber }}</span> |
                                <span class="ml-1">{{ customer.gstnumber }}</span>
                            </p>
                            <p>{{ customer.email }}</p>
                        </div>
                    </div>

                    <!-- Delete Button -->
                    <button class="cursor-pointer hover:scale-110 transition" (click)="$event.stopPropagation(); onDelete(customer.id)">
                        <svg class="w-6 h-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>

                </div>
            </div>
        </div>

    </div>

    <div *ngIf="activeSection === 'staff-list'">
        <app-gst-staff-list
            (editStaff)="onEditStaff($event)"
            (showAccessControl)="onShowAccessControl($event)">
        </app-gst-staff-list>
    </div>

    <!-- SECTION: Add Staff -->
    <div *ngIf="activeSection === 'add-staff'" class="mt-2">
        <app-gst-add-staff [editingStaffId]="editingStaffId"></app-gst-add-staff>
    </div>

    <!-- SECTION: Access Control -->
    <div *ngIf="activeSection === 'access-control'">
        <app-gst-admin-access-control
            [staffId]="accessControlStaffId"
            (backToStaffList)="onBackToStaffList()">
        </app-gst-admin-access-control>
    </div>

</div>
